import React from "react";
import { Menu, Layout } from "antd";
import { withRouter } from "react-router-dom";
const SubMenu = Menu.SubMenu;
const { Sider } = Layout;
class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
    };
  }
  clickHandler(event) {
    this.props.history.push(event.key);
  }
  collapsed = () => {
    this.setState({ collapse: !this.state.collapse });
  };
  render() {
    let navComponents = [];
    let i = 0;
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (this.props.userPermandMasters)
      this.props.userPermandMasters.SideMenus.map((item) => {
        let path = item.path === null || item.path === "" ? i++ : item.path;
        if (item.menuItemModels.length === 0) {
          if (role === "agency") {
            if (item.path === "/transactions") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Transactions</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Transactions</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/brokers") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Brokers</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Brokers</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/myenrollment") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Enrollment</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Enrollment</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/mybusiness") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Business </span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Business </span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/myinvites") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Invitations </span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Invitations</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/myplans") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Plans</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Plans</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>{item.name}</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>{item.name}</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            }
          } else if (role === "carrier") {
            if (item.path === "/transactions") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Transactions</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Transactions</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/myplans") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Plans</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Plans</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/mybusiness") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Business </span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Business </span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else if (item.path === "/myinvites") {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>Our Invitations </span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>Our Invitations</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            } else {
              if (!this.state.collapse)
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    key={path}
                  >
                    <i className={item.icon} />
                    <span style={{ marginLeft: "5px" }}>{item.name}</span>
                  </Menu.Item>
                );
              else
                navComponents.push(
                  <Menu.Item
                    onClick={() => (document.documentElement.scrollTop = 0)}
                    style={{ margin: "0px 5px" }}
                    title={<span>{item.name}</span>}
                    key={path}
                  >
                    <i style={{ marginLeft: "-7px" }} className={item.icon} />
                  </Menu.Item>
                );
            }
          } else {
            if (!this.state.collapse)
              navComponents.push(
                <Menu.Item
                  onClick={() => (document.documentElement.scrollTop = 0)}
                  key={path}
                >
                  <i className={item.icon} />
                  <span style={{ marginLeft: "5px" }}>{item.name}</span>
                </Menu.Item>
              );
            else
              navComponents.push(
                <Menu.Item
                  onClick={() => (document.documentElement.scrollTop = 0)}
                  style={{ margin: "0px 5px" }}
                  title={<span>{item.name}</span>}
                  key={path}
                >
                  <i style={{ marginLeft: "-7px" }} className={item.icon} />
                </Menu.Item>
              );
          }
        } else {
          let subComponentsBroker = [];
          item.menuItemModels.map((item) => {
            path = item.path === null || item.path === "" ? i++ : item.path;
            subComponentsBroker.push(
              <Menu.Item
                onClick={() => (document.documentElement.scrollTop = 0)}
                title={item.name}
                key={path}
              >
                <span style={{ marginLeft: "5px" }}>{item.name}</span>
              </Menu.Item>
            );
            return null;
          });
          if (subComponentsBroker.length) {
            if (!this.state.collapse)
              navComponents.push(
                <SubMenu
                  key={path}
                  title={
                    <span>
                      <i className={item.icon} />
                      <span style={{ marginLeft: "5px" }}>{item.name}</span>
                    </span>
                  }
                >
                  {subComponentsBroker}
                </SubMenu>
              );
            else
              navComponents.push(
                <SubMenu
                  style={{ margin: "0px 5px" }}
                  key={path}
                  title={
                    <span>
                      <i style={{ marginLeft: "-7px" }} className={item.icon} />
                    </span>
                  }
                >
                  {subComponentsBroker}
                </SubMenu>
              );
          }
        }
        return null;
      });
    let logo = "";
    if (!this.state.collapse) {
      logo = (
        <div className="logo" onClick={this.collapsed}>
          <i
            className="fa fa-bars menuicon"
            style={{ float: "right" }}
            aria-hidden="true"
          ></i>
        </div>
      );
    } else {
      logo = (
        <div
          style={{ margin: "20px 10px ", fontWeight: "bold" }}
          onClick={this.collapsed}
        >
          <h3 style={{ color: "var(--main-bg-color)" }}> MIcomp</h3>
        </div>
      );
    }
    return (
      <Sider
        trigger={null}
        theme="light"
        collapsed={this.state.collapse}
        collapsible
        width="220"
      >
        {logo}
        <Menu
          mode="inline"
          className="mi_ant_menu"
          selectedKeys={[window.location.pathname]}
          onClick={this.clickHandler.bind(this)}
        >
          {navComponents}
        </Menu>
      </Sider>
    );
  }
}
export default withRouter(Navigation);
